import { render, staticRenderFns } from "./addOzoneAlarmDialog.vue?vue&type=template&id=3f06e48d&scoped=true"
import script from "./addOzoneAlarmDialog.vue?vue&type=script&lang=js"
export * from "./addOzoneAlarmDialog.vue?vue&type=script&lang=js"
import style0 from "./addOzoneAlarmDialog.vue?vue&type=style&index=0&id=3f06e48d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f06e48d",
  null
  
)

export default component.exports